import { render, staticRenderFns } from "./projected_usage.vue?vue&type=template&id=437964fa"
import script from "./projected_usage.vue?vue&type=script&lang=js"
export * from "./projected_usage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports